import en from './messages/en.json';
import ko from './messages/ko.json';

export type Locale = 'en' | 'ko';

const messages: Record<Locale, typeof en> = {
  en,
  ko,
};

let currentLocale: Locale = 'en';

// Try to detect browser language
const browserLang = navigator.language.split('-')[0];
if (browserLang === 'ko') {
  currentLocale = 'ko';
}

// Check localStorage for saved preference
const savedLocale = localStorage.getItem('locale') as Locale | null;
if (savedLocale && (savedLocale === 'en' || savedLocale === 'ko')) {
  currentLocale = savedLocale;
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale): void {
  currentLocale = locale;
  localStorage.setItem('locale', locale);
  // Trigger re-render by dispatching custom event
  window.dispatchEvent(new CustomEvent('locale-change', { detail: locale }));
}

export function t(key: string, params?: Record<string, string | number>): string {
  const keys = key.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let value: any = messages[currentLocale];

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // Fallback to English
      value = messages.en;
      for (const fallbackKey of keys) {
        if (value && typeof value === 'object' && fallbackKey in value) {
          value = value[fallbackKey];
        } else {
          return key; // Return key if not found
        }
      }
      break;
    }
  }

  if (typeof value !== 'string') {
    return key;
  }

  // Replace parameters
  if (params) {
    return value.replace(/\{(\w+)\}/g, (_, paramKey) => {
      return params[paramKey]?.toString() ?? `{${paramKey}}`;
    });
  }

  return value;
}

export { messages };
